import { useState, useEffect } from "react";

// Typewriter hook - slowly reveals text
export const useTypewriter = (text, speed = 50) => {
  const [displayedText, setDisplayedText] = useState('');

  useEffect(() => {
    if (!text) {
      setDisplayedText('');
      return;
    }

    // If text is short, just show it immediately
    if (text.length < 10) {
      setDisplayedText(text);
      return;
    }

    let i = 0;
    setDisplayedText('');
    const timer = setInterval(() => {
      i++;
      setDisplayedText(text.substring(0, i));
      if (i >= text.length) clearInterval(timer);
    }, speed);

    return () => clearInterval(timer); // cleanup on unmount or text change
  }, [text, speed]);

  return displayedText;
};